import { Navigate } from "react-router-dom";

const GuestRoute = ({ children }) => {
  const userId = localStorage.getItem("userId");

  return userId !== null ? <Navigate to="/home" replace /> : children;
};

export default GuestRoute;
